import React from 'react';
import SiaContainer from '../../header/SiaContainer';
import Welcome from '../../../Presentational Components/Welcome';
import FactoryBoxContainer from '../../../Containers Components/FactoryBoxContainer';
import '../Style/aiFactory.css';
const AiFactoryView = (props) => (
    <>
        {props.isLoadAiFactory && <SiaContainer className='sia-container sia-container-factory' mainTitle=''>
            <div id='ai-factory-container'>
                <Welcome classNameH1='ai-factory-title' classNameImage='logo-responsive' classNameTop='ai-factory-top-container' />
                <FactoryBoxContainer {...props} />
            </div>
        </SiaContainer>}
    </>
);

export default AiFactoryView;
